import React, { useState, Activity } from "react";
import dayjs from "dayjs";
import {
  Modal,
  Upload,
  Button,
  notification,
  Form,
  Input,
  DatePicker,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { cfbhAxios } from "utilities/axios";
import config from "../../../config.js";

const UploadDocumentsModal = ({ visible, onClose, applicationId, appInfo }) => {
  const [form] = Form.useForm();

  const [fileList, setFileList] = useState([]);
  const [step, setStep] = useState(0);

  const handleUpload = () => {
    form
      .validateFields()
      .then(() => {
        const values = form.getFieldsValue(true);
        const formData = new FormData();
        formData.append("serial_no", values.serial_no);
        formData.append("serial_no_2", values.serial_no_2 || "");
        formData.append(
          "dispense_date",
          values.dispense_date ? values.dispense_date.format("YYYY-MM-DD") : "",
        );

        cfbhAxios
          .post(`/controllers/${applicationId}/documents-uploaded`, formData)
          .then(() => {
            notification.success({
              message: "Upload Successful",
              description: "Your documents have been uploaded successfully.",
            });
            onClose();
          })
          .catch((error) => {
            notification.error({
              message: "Upload Failed",
              description: `Failed to upload documents: ${error.message}`,
            });
          });
        onClose();
      })
      .catch((errorInfo) => {
        notification.error({
          message: "Validation Failed",
          description: "Please fill all required fields before uploading.",
        });
      });
  };
  return (
    <Modal
      title="Upload Documents"
      open={visible}
      onCancel={onClose}
      footer={
        step === 0
          ? [
              <Button key="cancel" onClick={onClose}>
                Cancel
              </Button>,
              <Button
                key="next"
                type="primary"
                onClick={() => {
                  form
                    .validateFields([
                      "serial_no",
                      "serial_no_2",
                      "dispense_date",
                    ])
                    .then(() => setStep(1))
                    .catch(() => {
                      notification.error({
                        message: "Validation Failed",
                        description:
                          "Please fill all required fields before proceeding.",
                      });
                    });
                }}
              >
                Next
              </Button>,
            ]
          : [
              <Button key="back" onClick={() => setStep(0)}>
                Previous
              </Button>,
              <Button key="submit" type="primary" onClick={handleUpload}>
                Submit
              </Button>,
            ]
      }
    >
      <Form
        form={form}
        preserve={true}
        layout="vertical"
        onFieldsChange={(changedFields, allFields) =>
          console.log(
            "Changed fields:",
            changedFields,
            "All fields:",
            allFields,
          )
        }
      >
        <Activity mode={step === 0 ? "visible" : "hidden"}>
          <Form.Item
            name="serial_no"
            label="Device 1 Serial Number"
            rules={[
              { required: true, message: "Please enter the serial number" },
            ]}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          {appInfo?.hearing_aid_count === 2 && (
            <Form.Item
              name="serial_no_2"
              label="Device 2 Serial Number"
              rules={[
                {
                  required: appInfo?.hearing_aid_count === 2,
                  message: "Please enter the serial number",
                },
              ]}
            >
              <Input style={{ width: "100%" }} />
            </Form.Item>
          )}
          <Form.Item
            name="dispense_date"
            label="Update Dispense Date"
            rules={[
              { required: true, message: "Please select the dispense date" },
            ]}
            initialValue={dayjs()}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Activity>
        <Activity mode={step === 1 ? "visible" : "hidden"}>
          <Form.Item
            name="documents"
            label="Upload Documents"
            rules={[
              {
                required: true,
                message: "Please upload at least one document",
              },
            ]}
          >
            <Upload
              multiple
              onChange={({ fileList: newFileList }) => setFileList(newFileList)}
              action={`${config.apiUrl}/cfbh/api/applications/${appInfo?.id}/documents`}
              withCredentials
              onRemove={(file) => {
                cfbhAxios
                  .delete(`/applications/${appInfo?.id}/documents/${file.name}`)
                  .then(() => {
                    notification.success({
                      message: "Document deleted successfully",
                    });
                  })
                  .catch(() => {
                    notification.error({
                      message: "Failed to delete document",
                    });
                  });
              }}
              fileList={fileList}
            >
              <Button icon={<UploadOutlined />}>Select Files</Button>
            </Upload>
          </Form.Item>
        </Activity>
      </Form>
    </Modal>
  );
};

export default UploadDocumentsModal;
